export const LOAD_API_DATA="LOAD_API_DATA@DATAASSETS"
export const SET_API_DATA = "SET_API_DATA@DATAASSETS"